import { Box } from '@material-ui/core';

import { SText } from '@setvi/shared/components';
import { Document } from '@setvi/shared/components/sresource-children-list/components/page-preview';
import type { Resource } from '@setvi/shared/interfaces';

import type { CoverPage } from '../../../../api/cover-templates';
import { useStyles } from './styles';

interface CoverThumbProps {
  template: CoverPage;
  /** The asset resource — the react-pdf base a cover PDF thumbnail renders on. */
  resource: Resource;
}

/** A cover page has no image thumbnail, so its PDF's first page stands in. */
export const CoverThumb = ({ template, resource }: CoverThumbProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.templateDoc}>
      <Document
        document={{ ...resource, DownloadURLWithSas: template.Url }}
        loading={false}
        activePage={1}
        loadingComponent={
          <Box className={classes.thumbLoading}>
            <SText
              title="Loading PDF..."
              size="xs"
              weight="bold"
              fontColor="#000000"
              maxLines="unset"
            />
          </Box>
        }
      />
    </Box>
  );
};
